export default __webpack_public_path__ + "static/media/list-view-active-icon.2fafd78c.svg";